export default __webpack_public_path__ + "static/media/customers.3ce2f29d.svg";